import { InputRow } from '../InputRow.jsx';
import { SoilDate } from '../SoilDate.jsx';
import { YieldReferenced } from '../YieldReferenced.jsx';

export function PhosphorusPotassiumFieldInputs({ nutrient, instance }) {
  const rx = instance[nutrient];
  const type = nutrient === 'phosphorus' ? 'P' : 'K';

  return (
    <>
      <InputRow name="Years to Critical" value={rx.yearsToCritical} />
      <InputRow name="Num of Cropping Years" value={rx.numberOfCroppingYears} />
      <InputRow name={`${type} Product`} value={rx.product} />
      <InputRow name={`${type} Groupings (lbs/ac)`} value={rx.grouping} />
      <InputRow
        name={`Other ${type} Apps (lbs/ac)`}
        value={rx.otherApplications}
      />
      <YieldReferenced rx={rx} />
      <SoilDate rx={rx} />
    </>
  );
}
